import { ElementRef, forwardRef } from 'react'
import { Button } from '@radix-ui/themes'
import cn from 'classnames'
import styles from './neon.module.scss'

type RadixButtonProps = React.ComponentPropsWithoutRef<typeof Button>

export interface NeonButtonProps extends Omit<
  RadixButtonProps,
  'color' | 'size' | 'variant'
> {
  color?: 'green' | 'pink'
  size?: 'md' | 'lg'
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
}

export const NeonButton = forwardRef<
  ElementRef<typeof Button>,
  NeonButtonProps
>(
  (
    {
      color = 'green',
      size = 'md',
      iconLeft,
      iconRight,
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        {...props}
        ref={ref}
        variant='solid'
        className={cn(
          styles.button,
          size === 'lg' ? styles.buttonLg : styles.buttonMd,
          { [styles.buttonPink]: color === 'pink' },
          className
        )}
      >
        {iconLeft ?
          <span className={styles.buttonIcon}>{iconLeft}</span>
        : null}

        {children}

        {iconRight ?
          <span className={styles.buttonIcon}>{iconRight}</span>
        : null}
      </Button>
    )
  }
)
